import L from "lodash/fp";
import inject from "scripts/ioc/inject";
import BaseView from "scripts/views/baseView";
import { addLinksToText } from "scripts/utils/viewHelpers";
import ContentDetailsPageAlsoFoundInSubPageView from "./contentDetailsPageAlsoFoundInSubPageView";
import templateCategoryLink from "../../templates/categoryLink.hbs";

const getDoiLink = doi =>
  doi ? (/^https?/.test(doi) ? doi : `https://doi.org/${doi}`) : null;

class BaseContentDetailsDetailsSubPageView extends BaseView {
  constructor(options, securityService = inject("securityService")) {
    super(options);

    this.securityService = securityService;

    this.alsoFoundInView = this.addSubView(
      new ContentDetailsPageAlsoFoundInSubPageView({
        model: new Backbone.Model({
          mediaId: this.model.get("id"),
        }),
      }),
    );
  }

  render() {
    const authScope = this.securityService.getAuthScopeFromSubdomain();

    const modelData = this.model.toJSON();
    modelData.audioType = L.capitalize(L.lowerCase(modelData.audioType));

    const attrs = L.merge(modelData, {
      attribution: addLinksToText(this.model.get("attribution")),
      doi: addLinksToText(getDoiLink(this.model.get("doi"))),
      isTorl: authScope === "openresearchlibrary",
    });

    this.$el.html(this.template(attrs));

    if (this.model.has("bisacCategories")) {
      this.addCategories(this.model.get("bisacCategories"));
    }

    if (this.alsoFoundInView) {
      this.alsoFoundInView
        .attachTo($("#bb-content-details-also-found-in-region"))
        .fetch()
        .then(() => this.alsoFoundInView.render());
    }

    return this;
  }

  get categoryTemplate() {
    return templateCategoryLink;
  }

  addCategories(categories) {
    const $categories = $(
      "#bb-content-details-book-page-details-sub-page-category-region",
    );

    const commaSeparatedCategoryLinks = categories
      .map(category => {
        return this.categoryTemplate(category);
      })
      .join(",&nbsp;");

    $categories.html(commaSeparatedCategoryLinks);
  }
}

export default BaseContentDetailsDetailsSubPageView;
